import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const InventorySections = styled("div")(
  ({ hasInfoSection }: { hasInfoSection?: boolean }) => ({
    height: "100%",
    display: "grid",
    gridTemplateColumns: hasInfoSection ? "70% 1fr" : "100%",
    gap: "16px",

    "@media screen and (max-width: 435px)": {
      display: "flex",
      flexDirection: "column",
    },
  })
);

export const RoomsSection = styled("div")(() => ({
  padding: "24px",
  backgroundColor: colors.white,
  borderRadius: "12px",

  "@media screen and (max-width: 435px)": {
    borderRadius: 0,
  },
}));
